import { Component, Input, OnInit } from '@angular/core';
import { IAuditLogDTO } from '../../dtos/get-audit-log.dto';
import { AnnualReportAction } from '../../interfaces/audit-log.interface';

@Component({
    selector: 'seal-history',
    templateUrl: './seal-history.component.html',
    styleUrls: ['./seal-history.component.scss'],
})
export class SealHistoryComponent implements OnInit {
    @Input() sealHistory: IAuditLogDTO[] = [];

    AnnualReportAction = AnnualReportAction;

    constructor() {}

    ngOnInit(): void {}
}
